module.exports = __webpack_public_path__ + "img/disable-protection.483be595.svg";